import $ from 'jquery';

$(function() {
  var $consent;
  if (document.cookie.indexOf('skp_cookie_consent=') === -1) {
    $consent = $(`<div id="cookie-consent" class="space-x-16 fixed text-center px-8 py-3.5 bottom-0 min-h-fit w-full z-[2000] bg-[#303030] text-white">
  <span id="cookie-description">
    Unsere Webseite setzt ausschließlich technisch notwendige Cookies (Funktionalitätscookies) ein, um Ihnen Dienste und Funktionen bereitstellen und das Website-Angebot verbessern zu können.
    Weitere Informationen erhalten Sie in unserer <a class="privacy-link text-white" href="https://skp.community/legal/privacy">Datenschutzerklärung.</a>
  </span>
  <span id="cookie-accept pl-16">
    <button id="skp-accept-button" class="btn btn-primary">OKAY</button>
  </span>
</div>`);
    $consent.on('click', '#skp-accept-button', function(e) {
      var cookieDate;
      e.preventDefault();
      cookieDate = new Date();
      cookieDate.setTime((new Date()).getTime() + 1000 * 60 * 60 * 24 * 365);
      document.cookie = `skp_cookie_consent=1; path=/; secure; expires=${cookieDate.toUTCString()}`;
      return $consent.remove();
    });
    return $consent.appendTo($('body'));
  }
});
